import React from "react";
import SectionHero from "components/SectionHero/SectionHero";
import rightImg from "images/about-hero-right.png";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import Layout from "../(others)/layout"
import ExpertiseTooltip from "components/Tooltip/ExpertiseTooltip";
import "../../styles/styles.css"


const PageServices = () => {
  return (
    <Layout>
      
        
        <div className={`nc-PageAbout relative`}>
        
            <div className="flex flex-col lg:flex-row space-y-14 lg:space-y-0 lg:space-x-10 items-center relative text-center lg:text-left">
              <div className="w-screen max-w-full xl:max-w-lg space-y-5 lg:space-y-7">
              <ExpertiseTooltip  />
                <h2 className="inline-block align-middle text-4xl font-semibold md:text-5xl">
                  Services
                </h2>
                <span className="block text-base xl:text-lg text-neutral-6000 dark:text-neutral-400">
                Visionnaire Drone est un service d’imagerie aérienne par drone. Quel que soit votre projet, Visionnaire Drone est le moyen idéal pour créer votre contenu visuel. Nous effectuons des tournages par drone lors de visites intérieures et/ou extérieures en qualité 4K. Photos et vidéos sont ensuite assemblés en montage vidéo avec des logiciels spécialisés.
                </span>
                
              </div>
              <table className="flex-grow">
                <tbody></tbody>
                <tr>
                  <td>
                    <img className="arrondie" src="../../images/Services1.jpg" />
                  </td>
                  <td>
                    <img className="arrondie" src="../../images/Services2.jpg" />
                  </td>
                  <td>
                    <img className="arrondie" src="../../images/Services3.jpg" />
                  </td>
                  <td>
                    <img className="arrondie" src="../../images/Services4.jpg" />
                  </td>
                  <td>
                    <img className="arrondie" src="../../images/Services5.jpg" />
                  </td>
                </tr>
              </table>
            </div>
            </div>
     
  
    </Layout>
  );
};

export default PageServices;
